/**
 * Mirror of `apps/server/src/services/env-links/recipes.ts:studioSlug`. Kept
 * client-side so the UI can preview the slug before posting and so the
 * "Add studio" form can use the slug as a stable key. The server still
 * runs its own slugger on input as a defence-in-depth measure.
 */
export function studioSlugClient(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
